import { GoogleMap, Marker } from "@react-google-maps/api";

export default function AddressMap({ position, onSelect }) {
  const containerStyle = {
    width: "100%",
    height: "300px",
    borderRadius: "12px",
    overflow: "hidden",
  };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={position}
      zoom={17}
      onClick={(e) => onSelect(e.latLng.lat(), e.latLng.lng())}
    >
      <Marker
        position={position}
        draggable={true}
        onDragEnd={(e) => onSelect(e.latLng.lat(), e.latLng.lng())}
      />
    </GoogleMap>
  );
}
